module.exports = __webpack_public_path__ + "img/absolute-radio-60s.8c9efb7b.png";